module.exports = __webpack_public_path__ + "img/banner-autoshop.29afab12.jpg";